import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"

import { API_M2M_IN_URL } from "../constants"
import { RootState } from "../../store/store"
import { IRequestErrorWithErrors } from "../interface"
import { axios } from "../axios"
import { getFingerPrint } from "../../utils/fingerprint"

async function put(
  token: string | null,
  incomeTransferRequestId: string,
  fingerprint: string | null
) {
  // TODO: добавить передачу фингерпринта
  await axios(
    `${API_M2M_IN_URL}/${incomeTransferRequestId}/accept`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        fingerprint
      }
    },
  )
  // TODO: добавить обработку ошибок
}

export const useAcceptSbpIncomeTransferRequest = () => {
  const token = useSelector((state: RootState) => state.auth.token)
  const fingerprint = getFingerPrint(false)

  return useMutation<void, IRequestErrorWithErrors, string>({
    mutationFn: (incomeTransferRequestId) =>
      put(token, incomeTransferRequestId, fingerprint),
  })
}
